import LoaderOverlay from "@edaz/edazkit/LoaderOverlay/index";
import { observer } from "mobx-react-lite";
import React from "react";
import Modal from "react-bootstrap/Modal";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import ChangeVehicleViewModel from "viewModels/callCenter/actions/changeVehicleViewModel";
import ChangeVehicleForm from "./changeVehicleForm";
import ChangeVehicleSearchResults from "./changeVehicleSearchResults";
import { formatLicensePlate } from "utils/localizations";
import AlertWithIcon from "views/common/alertWithIcon";

export const ChangeVehicleView: ViewComponent<ChangeVehicleViewModel> = observer(({ vm }) => {
  return (
    <Modal
      show={true}
      onHide={vm.requestClose}
      scrollable={vm.secondStep}
      dialogClassName={vm.secondStep ? "modal-90w" : "modal-md"}
      centered>
      <Modal.Header closeButton={true} className="d-flex align-items-center pb-0">
        <Modal.Title>
          {vm.secondStep
            ? `${vm.name} ${formatLicensePlate({
                licensePlate: vm.item.oldLicensePlate,
                countryId: vm.item.oldCountryId,
              })}`
            : vm.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={vm.secondStep ? "full-width" : undefined} style={{ paddingBottom: "1.5rem" }}>
        {vm.noChargesNoExemptionsWarning && (
          <AlertWithIcon className="mt-3 mb-3" variant="danger">
            {vm.translate("noChargesNoExemptionsWarning")}
          </AlertWithIcon>
        )}
        <LoaderOverlay loading={vm.busyWatcher.isBusy}>
          {vm.secondStep ? <ChangeVehicleSearchResults vm={vm} /> : <ChangeVehicleForm vm={vm} />}
        </LoaderOverlay>
      </Modal.Body>
    </Modal>
  );
});

registerView(ChangeVehicleView, ChangeVehicleViewModel);
